import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {BOOKING_DATA_DEFAULT} from './constants';
import {BookingStore} from './types';

export const useBookingStore = create<BookingStore>()(
	persist(
		set => ({
			bookingData: BOOKING_DATA_DEFAULT,

			setBookingData: data =>
				set(state => {
					const newData = typeof data === 'function' ? data(state.bookingData) : data;

					return {
						bookingData: {
							...state.bookingData,
							...newData,
						},
					};
				}),

			resetBookingData: (override = {}) =>
				set({
					bookingData: {...BOOKING_DATA_DEFAULT, ...override},
				}),
		}),
		{
			name: 'bookingData',
		},
	),
);
